import React from "react";

import { EmployeeInfo } from "../../components/EmployeeInfo/EmployeeInfo";

export const Signup: React.FC = () => {
    
    return (
        <div className="signup-page">
            <EmployeeInfo signup={true} />
        </div>
    );
};

require('./styles.scss')
